(function () {
  var SECTION_SELECTOR = '.oddit-section-card-carousel';

  function debounce(fn, wait) {
    var rafId = null;
    var lastArgs = null;
    return function () {
      lastArgs = arguments;
      if (rafId) return;
      rafId = requestAnimationFrame(function () {
        rafId = null;
        fn.apply(null, lastArgs);
      });
    };
  }

  function initSection(section) {
    var track = section.querySelector('.oddit-section-card-carousel__track');
    var dots = Array.prototype.slice.call(
      section.querySelectorAll('.oddit-section-card-carousel__dot')
    );
    var slides = Array.prototype.slice.call(
      section.querySelectorAll('.oddit-section-card-carousel__slide')
    );

    if (!track || dots.length === 0 || slides.length === 0) return;

    var indicatorsEl = section.querySelector('.oddit-section-card-carousel__indicators');

    function getFullyVisibleCount() {
      if (!slides.length) return 1;
      var slideW = slides[0].getBoundingClientRect().width;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      var step = slideW + gap;
      if (step <= 0) return 1;
      return Math.max(1, Math.floor((track.clientWidth + gap) / step));
    }

    function getPageCount() {
      var maxScroll = track.scrollWidth - track.clientWidth;
      if (maxScroll <= 1) return 0;
      return Math.max(1, slides.length - getFullyVisibleCount() + 1);
    }

    function targetScrollFor(pageIndex) {
      var pages = getPageCount();
      if (pages <= 1) return 0;
      // First page: scroll 0. Last page: scroll to maxScroll (right-aligned).
      // Intermediate pages: snap to slide[pageIndex]'s leftmost position.
      if (pageIndex <= 0) return 0;
      var maxScroll = track.scrollWidth - track.clientWidth;
      if (pageIndex >= pages - 1) return Math.max(0, maxScroll);
      var slide = slides[pageIndex];
      if (!slide) return 0;
      return Math.min(maxScroll, slide.offsetLeft - track.offsetLeft);
    }

    function updateDotVisibility() {
      var pages = getPageCount();
      if (indicatorsEl) indicatorsEl.hidden = pages <= 1;
      for (var i = 0; i < dots.length; i++) {
        dots[i].hidden = i >= pages;
      }
    }

    function getCurrentIndex() {
      // Map scrollLeft to the nearest page-target so the active dot reflects
      // which "page" the user is sitting on, including the right-aligned end.
      var pages = getPageCount();
      if (pages <= 1) return 0;
      var refLeft = track.scrollLeft;
      var bestIndex = 0;
      var bestDistance = Infinity;
      for (var i = 0; i < pages; i++) {
        var target = targetScrollFor(i);
        var distance = Math.abs(target - refLeft);
        if (distance < bestDistance) {
          bestDistance = distance;
          bestIndex = i;
        }
      }
      return bestIndex;
    }

    function setActiveDot(index) {
      for (var i = 0; i < dots.length; i++) {
        var isActive = i === index;
        dots[i].classList.toggle(
          'oddit-section-card-carousel__dot--active',
          isActive
        );
        if (isActive) {
          dots[i].setAttribute('aria-current', 'true');
        } else {
          dots[i].removeAttribute('aria-current');
        }
      }
    }

    function goToSlide(index) {
      var pages = getPageCount();
      if (pages <= 1) return;
      if (index < 0 || index >= pages) return;
      track.scrollTo({ left: targetScrollFor(index), behavior: 'smooth' });
      setActiveDot(index);
    }

    var onScroll = debounce(function () {
      setActiveDot(getCurrentIndex());
    });

    track.addEventListener('scroll', onScroll, { passive: true });

    // Mouse drag-to-scroll (MBG-52).
    var drag = {
      active: false,
      pointerId: null,
      startX: 0,
      startScrollLeft: 0,
      moved: false
    };
    var DRAG_MOVE_THRESHOLD = 4;

    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      if (e.button !== 0) return;
      drag.active = true;
      drag.pointerId = e.pointerId;
      drag.startX = e.clientX;
      drag.startScrollLeft = track.scrollLeft;
      drag.moved = false;
    });

    track.addEventListener('pointermove', function (e) {
      if (!drag.active || e.pointerId !== drag.pointerId) return;
      var dx = e.clientX - drag.startX;
      if (!drag.moved) {
        if (Math.abs(dx) < DRAG_MOVE_THRESHOLD) return;
        drag.moved = true;
        track.classList.add('oddit-section-card-carousel__track--dragging');
        track.style.scrollSnapType = 'none';
        try { track.setPointerCapture(drag.pointerId); } catch (err) {}
      }
      track.scrollLeft = drag.startScrollLeft - dx;
      if (e.cancelable) e.preventDefault();
    });

    function endDrag(e) {
      if (!drag.active || (e && e.pointerId !== drag.pointerId)) return;
      var wasMoved = drag.moved;
      drag.active = false;
      drag.pointerId = null;
      try { track.releasePointerCapture(e && e.pointerId); } catch (err) {}
      if (!wasMoved) return;
      track.classList.remove('oddit-section-card-carousel__track--dragging');
      var nearest = getCurrentIndex();
      track.scrollTo({ left: targetScrollFor(nearest), behavior: 'smooth' });
      setActiveDot(nearest);
      setTimeout(function () { track.style.scrollSnapType = ''; }, 400);
    }

    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    track.addEventListener('click', function (e) {
      if (drag.moved) {
        e.preventDefault();
        e.stopPropagation();
        drag.moved = false;
      }
    }, true);

    // Forward predominantly-vertical wheel events to the page (MBG-51).
    track.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
        e.preventDefault();
        window.scrollBy({ top: e.deltaY, behavior: 'auto' });
      }
    }, { passive: false });

    for (var i = 0; i < dots.length; i++) {
      (function (idx) {
        dots[idx].addEventListener('click', function () {
          goToSlide(idx);
        });
      })(i);
    }

    var ro = (typeof ResizeObserver !== 'undefined')
      ? new ResizeObserver(debounce(function () {
          updateDotVisibility();
          setActiveDot(getCurrentIndex());
        }))
      : null;
    if (ro) ro.observe(track);
    window.addEventListener('resize', debounce(function () {
      updateDotVisibility();
      setActiveDot(getCurrentIndex());
    }));

    updateDotVisibility();
    setActiveDot(getCurrentIndex());
  }

  function init() {
    var sections = document.querySelectorAll(SECTION_SELECTOR);
    for (var i = 0; i < sections.length; i++) {
      initSection(sections[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();